import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Languages, Palette, Smartphone } from 'lucide-react';
import { useLanguage } from '../../i18n/LanguageContext';
import { localeOption } from '../../i18n/locales';
import { useTheme } from '../../theme/ThemeContext';
import { SETTINGS_DEFAULTS, SETTINGS_LANGUAGE, SETTINGS_THEME } from './settings-paths';
import './settings-home.css';

const SettingsHome: React.FC = () => {
  const { t, locale } = useLanguage();
  const { theme } = useTheme();
  const language = localeOption(locale);

  const rows = [
    {
      to: SETTINGS_THEME,
      tone: 'theme',
      icon: Palette,
      title: t('settings.home.theme.title'),
      desc: t('settings.home.theme.desc'),
      meta: t(theme === 'dark' ? 'theme.mode.dark' : 'theme.mode.light'),
    },
    {
      to: SETTINGS_LANGUAGE,
      tone: 'language',
      icon: Languages,
      title: t('settings.home.language.title'),
      desc: t('settings.home.language.desc'),
      meta: language.nativeName,
    },
    {
      to: SETTINGS_DEFAULTS,
      tone: 'phone',
      icon: Smartphone,
      title: t('settings.home.defaults.title'),
      desc: t('settings.home.defaults.desc'),
      meta: t('defaults.browserChip'),
    },
  ];

  return (
    <div className="set">
      <div className="set-stack">
        {rows.map((row) => {
          const Icon = row.icon;
          return (
            <Link key={row.to} className="set-row" to={row.to}>
              <span className={`set-ico set-ico--${row.tone}`}>
                <Icon size={22} aria-hidden="true" />
              </span>
              <span className="set-row__copy">
                <span className="set-row__title">{row.title}</span>
                <span className="set-row__desc">{row.desc}</span>
              </span>
              <span className="set-row__meta">{row.meta}</span>
              <ChevronRight className="set-chevron" size={18} aria-hidden="true" />
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default SettingsHome;
